export const InformationIcon = () => {
    return (
        <svg
            width="18"
            height="18"
            viewBox="0 0 18 18"
            fill="none"
            xmlns="http://www.w3.org/2000/svg"
        >
            <circle cx="9" cy="9" r="9" fill="white" />
            <path
                d="M9.92236 6.0752V14H7.98145V6.0752H9.92236ZM7.84961 4.00244C7.84961 3.71436 7.94727 3.4751 8.14258 3.28467C8.34277 3.09424 8.61133 2.99902 8.94824 2.99902C9.28516 2.99902 9.55127 3.09424 9.74658 3.28467C9.94678 3.4751 10.0469 3.71436 10.0469 4.00244C10.0469 4.28564 9.94678 4.52246 9.74658 4.71289C9.55127 4.90332 9.28516 4.99854 8.94824 4.99854C8.61133 4.99854 8.34277 4.90332 8.14258 4.71289C7.94727 4.52246 7.84961 4.28564 7.84961 4.00244Z"
                fill="black"
            />
        </svg>
    );
};
